// extracted by mini-css-extract-plugin
export var stepActive = "_2b-3";
export var stepCompleted = "_2b-4";
export var stepConnectorLine = "_2b-b";
export var stepIndicatorCircle = "_2b-6";
export var stepIndicatorCircleCompleted = "_2b-7";
export var stepIndicatorCircleDefault = "_2b-8";
export var stepIndicatorTextCompleted = "_2b-9";
export var stepIndicatorTextDefault = "_2b-a";
export var stepPending = "_2b-5";
export var wizardContainer = "_2b-1";
export var wizardContent = "_2b-2";
export var wizardModal = "_2b-0";